module.exports = "img/flags/EG.d92a29b.png";